import {ConfigObjectType, useApiQuery} from '@wallaby-ui/core';

import {AlertBoardDto} from './alert_board_types';

type UseAlertBoardReturn = {
  board: AlertBoardDto | undefined;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
};

/**
 * The alert board read (PDW-184): `GET {alertBoard}` with the filter and the sorts as query parameters, a set as one
 * comma-separated value. The KPI strip and every alert come in one response, so they always agree. Fetched
 * again on every mount and filter change: episodes change without anything the product stores changing (no ETag).
 */
export function useAlertBoard(config: ConfigObjectType, params: URLSearchParams, enabled: boolean): UseAlertBoardReturn {
  const url: string = config.service.url.alertBoard ?? '';
  const {data, isLoading, isError, refetch} = useApiQuery<AlertBoardDto>([url, String(params)], null, {
    axiosConfig: {url, params},
    reactQueryOptions: {
      enabled: enabled && Boolean(url),
      staleTime: 0,
      refetchOnMount: 'always',
      keepPreviousData: true,
    },
  });
  return {board: data, isLoading, isError, refetch};
}
